module.exports = __webpack_public_path__ + "static/media/Thumbs.ff76cb94.db";